<button class="download-btn" (click)="onClick(metaFileLink)"
    >
    <div class="icon">
        <mat-icon class="notranslate" svgIcon="apk_install"></mat-icon>
    </div>
    <p>{{text || metaFileLink.title}}</p>
</button>